// Module
var code = "<a href=\"#\" data-bind=\"attr: {'data-text': $parent.GetValue(Name)}\"><!-- ko text: _labels.EDIT --><!-- /ko --></a>";
// Exports
export default code;